import React, { useState, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import Announcement, {
  animations,
} from '@groovehq/internal-design-system/lib/components/Announcement/Announcement'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { styles } from '@groovehq/internal-design-system/lib/components/Announcement/Announcement.styles'
import {
  anchor,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { HIDE_FEATURES_ANNOUNCEMENT } from 'ducks/flags/flagNames'
import { doSetFlag } from 'ducks/flags/operations'
import { styles as layoutStyles } from './styles'

const CHANGELOG_URL = 'https://groovehq.canny.io/changelog'

// Monthly update checklist:
// 1. Update the title/copy below.
// 2. Roll HIDE_FEATURES_ANNOUNCEMENT to the new month in
//    ducks/flags/flagNames.js so every agent sees the new post once.
// 3. Bump the date in selectShouldHideFeaturesAnnoucement
//    (ducks/flags/selectors.js) — the banner auto-hides 30 days after it.
const TITLE = '🚀 See What’s New in Groove'
const PARAGRAPH_1 =
  'This month we launched Groove Copilot for all accounts, introduced Copilot Guidance and AI feedback improvements, delivered major performance and reliability upgrades, improved Knowledge Base customization and search, added new security controls like 2FA resets, and shipped dozens of smaller enhancements and bug fixes to make Groove faster and easier to use.'
const PARAGRAPH_2_LINK_TEXT = 'What’s New changelog'
const PARAGRAPH_2_REST =
  '. Just click the 📣 loudspeaker icon in the top-right corner of your Groove account to see everything we’ve recently shipped.'

const NewFeaturesAnnouncement = () => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(true)

  const handleCloseCard = useCallback(
    () => {
      setShow(false)
      dispatch(doSetFlag(HIDE_FEATURES_ANNOUNCEMENT))
    },
    [dispatch]
  )

  const footer = useMemo(
    () => (
      <div className="grui pb-12 text-center">
        <Button
          as="a"
          href={CHANGELOG_URL}
          target="_blank"
          rel="noopener noreferrer"
          type="info"
          size="xBig"
          css={styles.btn}
          onClick={handleCloseCard}
        >
          See everything we’ve shipped
        </Button>
      </div>
    ),
    [handleCloseCard]
  )

  return (
    <div css={layoutStyles.announcementContainer}>
      <Announcement.AnimatePresenceMotion
        open={show}
        initialAnimation={animations.initial}
        endAnimation={animations.end}
      >
        <Announcement
          onClose={handleCloseCard}
          tag="What’s New"
          title={TITLE}
          copy={
            <>
              {PARAGRAPH_1}
              <br />
              <br />
              {'Stay up to date by checking out our '}
              <a
                href={CHANGELOG_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleCloseCard}
                css={[anchor.styles.preflight, button.styles.link]}
              >
                {PARAGRAPH_2_LINK_TEXT}
              </a>
              {PARAGRAPH_2_REST}
            </>
          }
          footer={footer}
        />
      </Announcement.AnimatePresenceMotion>
    </div>
  )
}

export default NewFeaturesAnnouncement
